<template>
  <div class="row relative-section">
    <div class="col-md-6">
      <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
        <div class="panel panel-primary heading-border">
          <div class="panel-heading">
            <span class="panel-title">
                <i class="fa fa-pencil-square"></i>
                Отправка SMS оттока
            </span>
          </div>
          <div class="panel-body p25">


            <div class="section row mb25 fs11">
              <div class="col-md-12">
                Шаблон:<br>
                <b>#ОСТАТОК#</b> - Осталось занятий на абонементе<br>
                <b>#ИСТЕКАЕТ#</b> - Дата, когда заканчивается абонемент<br>
                <b>#СООБЩЕНИЕ ОСТАТКА#</b> - Сообщение из блока "Остаток неиспользованных посещений"<br>
                <b>#СКИДКА#</b> - Текущая скидка клиента
              </div>
            </div>

            <div class="section row mb25">
              <loading :active="loadings.sms_status_text_expired_before_3_month" color="#4c4a49" :is-full-page="false"/>
              <div class="col-md-12">
                <label class="field-label">
                  Сообщение "Отток до 3 месяцев"
                  <span class="fs11">
                    ({{ parameters.sms_status_text_expired_before_3_month ? parameters.sms_status_text_expired_before_3_month.length : 0 }}
                    {{ parameters.sms_status_text_expired_before_3_month ? parameters.sms_status_text_expired_before_3_month.length : 0 | pluralForm(['символ', 'символа', 'символов']) }})
                  </span>
                </label>
                <label class="field prepend-icon">
                  <textarea class="gui-textarea"
                    v-model.trim="parameters.sms_status_text_expired_before_3_month"
                    @change="updateParameter('sms_status_text_expired_before_3_month')"
                  ></textarea>
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
              </div>
            </div>

            <div class="section row mb25">
              <loading :active="loadings.sms_status_text_expired_before_6_month" color="#4c4a49" :is-full-page="false"/>
              <div class="col-md-12">
                <label class="field-label">
                  Сообщение "Отток до 6 месяцев"
                  <span class="fs11">
                    ({{ parameters.sms_status_text_expired_before_6_month ? parameters.sms_status_text_expired_before_6_month.length : 0 }}
                    {{ parameters.sms_status_text_expired_before_6_month ? parameters.sms_status_text_expired_before_6_month.length : 0 | pluralForm(['символ', 'символа', 'символов']) }})
                  </span>
                </label>
                <label class="field prepend-icon">
                  <textarea class="gui-textarea"
                    v-model.trim="parameters.sms_status_text_expired_before_6_month"
                    @change="updateParameter('sms_status_text_expired_before_6_month')"
                  ></textarea>
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
              </div>
            </div>

            <div class="section row mb25">
              <loading :active="loadings.sms_status_text_expired_after_6_month" color="#4c4a49" :is-full-page="false"/>
              <div class="col-md-12">
                <label class="field-label">
                  Сообщение "Отток более 6 месяцев"
                  <span class="fs11">
                    ({{ parameters.sms_status_text_expired_after_6_month ? parameters.sms_status_text_expired_after_6_month.length : 0 }}
                    {{ parameters.sms_status_text_expired_after_6_month ? parameters.sms_status_text_expired_after_6_month.length : 0 | pluralForm(['символ', 'символа', 'символов']) }})
                  </span>
                </label>
                <label class="field prepend-icon">
                  <textarea class="gui-textarea"
                    v-model.trim="parameters.sms_status_text_expired_after_6_month"
                    @change="updateParameter('sms_status_text_expired_after_6_month')"
                  ></textarea>
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
              </div>
            </div>

            <div class="section row mb25">
              <loading :active="loadings.sms_status_text_expired_not_used" color="#4c4a49" :is-full-page="false"/>
              <div class="col-md-12">
                <label class="field-label">
                  Остаток неиспользованных посещений
                  <span class="fs11">
                    ({{ parameters.sms_status_text_expired_not_used ? parameters.sms_status_text_expired_not_used.length : 0 }}
                    {{ parameters.sms_status_text_expired_not_used ? parameters.sms_status_text_expired_not_used.length : 0 | pluralForm(['символ', 'символа', 'символов']) }})
                  </span>
                </label>
                <label class="field prepend-icon">
                  <textarea class="gui-textarea"
                    v-model.trim="parameters.sms_status_text_expired_not_used"
                    @change="updateParameter('sms_status_text_expired_not_used')"
                  ></textarea>
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
              </div>
            </div>

            <div class="section row mb25">
              <loading :active="loadings.sms_status_text_subscription_end" color="#4c4a49" :is-full-page="false"/>
              <div class="col-md-12">
                <label class="field-label">
                  Окончание абонемента
                  <span class="fs11">
                    ({{ parameters.sms_status_text_subscription_end ? parameters.sms_status_text_subscription_end.length : 0 }}
                    {{ parameters.sms_status_text_subscription_end ? parameters.sms_status_text_subscription_end.length : 0 | pluralForm(['символ', 'символа', 'символов']) }})
                  </span>
                </label>
                <label class="field prepend-icon">
                  <textarea class="gui-textarea"
                    v-model.trim="parameters.sms_status_text_subscription_end"
                    @change="updateParameter('sms_status_text_subscription_end')"
                  ></textarea>
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
                <label class="field-label">
                  Уведомлять за {{parameters.sms_status_subscription_end_days}}
                  {{parameters.sms_status_subscription_end_days | pluralForm(['день', 'дня', 'дней'])}}
                  до окончания абонемента
                </label>
                <label class="field prepend-icon">
                  <input class="gui-input"
                    v-model.trim="parameters.sms_status_subscription_end_days"
                    @change="updateParameter('sms_status_subscription_end_days')"
                  >
                  <label class="field-icon">
                    <i class="fa fa-edit"></i>
                  </label>
                </label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationError from '../../classes/ValidationError'
import Parameter from '../../models/v2/Parameter'

export default {
  components: {
    Loading: () => import('vue-loading-overlay'),
  },
  async beforeRouteEnter (to, from, next) {
    let parametersList = await Parameter.getList()
    next(component => {
      component.parameters = parametersList
    })
  },
  data () {
    return {
      loadings: {
        sms_status_text_expired_before_3_month: false,
        sms_status_text_expired_before_6_month: false,
        sms_status_text_expired_after_6_month: false,
        sms_status_text_expired_not_used: false,
        sms_status_text_subscription_end: false,
        sms_status_subscription_end_days: false,
      },
      parameters: {
        sms_status_text_expired_before_3_month: '',
        sms_status_text_expired_before_6_month: '',
        sms_status_text_expired_before_12_month: '',
        sms_status_text_expired_after_12_month: '',
        sms_status_text_expired_not_used: '',
        sms_status_text_subscription_end: '',
        sms_status_subscription_end_days: '',
      },
    }
  },
  methods: {
    async updateParameter (name) {
      this.loadings[name] = true

      try {
        await Parameter.update(name, this.parameters[name])

        this.$notify({
          type: 'success',
          text: 'Сохранено',
          duration: 2000,
        })
      } catch (error) {
        if (error instanceof ValidationError) {
          this.$notify({
            type: 'error',
            text: error.errors,
            duration: 10000,
          })
        } else {
          console.error(error)
        }
      }

      this.loadings[name] = false
    },
  },
  metaInfo () {
    return {
      title: 'Параметры - редактирование',
      meta: [
        { vmid: 'description', name: 'description', content: '' },
        { vmid: 'keywords', name: 'keywords', content: '' },
      ],
    }
  },
}
</script>
